import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Ville } from 'src/app/models/Ville';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VilleService {

  

  PATH_VILLE_BY_DEP = "/programmes-lots/ville/by-departement/";
  PATH_VILLE_ALL = "/programmes-lots/ville/all";
  PATH_VILLE_BY_REGION = "/programmes-lots/ville/by-region/";

  constructor(private readonly http: HttpClient) { }
  
  getAllcities = (): Observable<Ville[]> => {
    const url = environment.host.domaine + this.PATH_VILLE_ALL;
    return this.http.get<Ville[]>(url)
  }

  getAllcitiesbyRegion = (code: number): Observable<Ville[]> => {
    const url = environment.host.domaine + this.PATH_VILLE_BY_REGION;
    return this.http.get<Ville[]>(url+code)
  }
  getCitiesByDep = (code: string): Observable<Ville[]> => {
    const url = environment.host.domaine + this.PATH_VILLE_BY_DEP;
    return this.http.get<Ville[]>(url+code)
  }
}
